import { render } from "./login.vue?vue&type=template&id=a78d0d26&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=a78d0d26&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator.DESKTOP-7G84OHA\\Desktop\\dduh-active-webh5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78d0d26"]])

export default __exports__